import type { Meta } from '../db/tipos'
import { arredondar2 } from '../pedidos/precos'
import type { NumerosDoMes } from './historico'
import type { Base } from './destrave'
import type { Passos } from './configuracao'
import { aplicarEmpurrao } from './regua'

export interface Sugestao {
  tipo: Meta['tipo']
  media: number
  alvo: number
  mesesUsados: number
}

export interface ResultadoSugestao {
  podeSugerir: boolean
  motivo: string | null
  sugestoes: Sugestao[]
}

export interface EntradaSugestao {
  base: Base
  historico: Record<string, NumerosDoMes> // '2026-07' -> numeros
  mesAlvo: string // '2026-10'
  passos: Passos
  tipos: Meta['tipo'][]
}

const JANELA: Record<'tres_meses' | 'seis_meses', number> = { tres_meses: 3, seis_meses: 6 }

function mesesDaJanela(historico: Record<string, NumerosDoMes>, quantos: number): NumerosDoMes[] {
  return Object.keys(historico)
    .sort()
    .slice(-quantos)
    .map((mes) => historico[mes])
}

export function sugerir(entrada: EntradaSugestao): ResultadoSugestao {
  const { base, historico, mesAlvo, passos, tipos } = entrada

  if (base === 'anual') {
    const sufixo = mesAlvo.slice(5) // '10'
    const mesmosMeses = Object.entries(historico)
      .filter(([mes, n]) => mes.slice(5) === sufixo && mes < mesAlvo && n.temVenda)
      .map(([, n]) => n)
    if (mesmosMeses.length === 0) {
      return { podeSugerir: false, motivo: 'Não há esse mês em nenhum ano anterior.', sugestoes: [] }
    }
    // O MELHOR ano ja E o empurrao: e uma marca para bater de novo. Por isso o
    // crescimento observado nao entra em cima (decisao dela, spec §6).
    const sugestoes = tipos.map((tipo) => {
      const melhor = Math.max(...mesmosMeses.map((n) => n[tipo]))
      return {
        tipo, media: arredondar2(melhor),
        alvo: aplicarEmpurrao(tipo, melhor, passos),
        mesesUsados: mesmosMeses.length,
      }
    })
    return { podeSugerir: true, motivo: null, sugestoes }
  }

  const janela = mesesDaJanela(historico, JANELA[base])
  const comVenda = janela.filter((n) => n.temVenda)
  if (comVenda.length === 0) {
    // ⚠ Zero e UM sao situacoes diferentes para quem le: dizer "so um mes" sem
    // nenhuma venda no periodo e simplesmente falso (decisao dela, 2026-08-06).
    return {
      podeSugerir: false,
      motivo: 'Sem venda nenhuma no período — não dá para sugerir.',
      sugestoes: [],
    }
  }
  if (comVenda.length < 2) {
    return {
      podeSugerir: false,
      // Media de um mes so e o que a regra dos 3 meses existe para evitar.
      motivo: 'Só um mês com venda no período — pouco para sugerir.',
      sugestoes: [],
    }
  }

  const sugestoes = tipos.map((tipo) => {
    const media = comVenda.reduce((soma, n) => soma + n[tipo], 0) / comVenda.length
    return {
      tipo, media: arredondar2(media),
      alvo: aplicarEmpurrao(tipo, media, passos),
      mesesUsados: comVenda.length,
    }
  })
  return { podeSugerir: true, motivo: null, sugestoes }
}
